import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { FieldWrapper } from "@progress/kendo-react-form";
import { useJobSetupStore } from "@presentation/stores/JobSetupStore";
import { buildQuantificationOptions, LABEL_FREE, type QuantificationOption } from "./quantificationOptions";

/**
 * Quantification method selection. Rendered only for SpectroMine jobs: Spectronaut has
 * no equivalent flag and the backend rejects the field for any other engine.
 */
export const QuantificationSelectionBlock: React.FC = () => {
  const quantificationMethod = useJobSetupStore((state) => state.CreateJobState.quantificationMethod);
  const setQuantificationMethod = useJobSetupStore((state) => state.setQuantificationMethod);

  const options = React.useMemo(() => buildQuantificationOptions(quantificationMethod), [quantificationMethod]);
  const selected = options.find((option) => option.value === quantificationMethod) ?? LABEL_FREE;

  return (
    <fieldset className="k-form-fieldset">
      <legend className="k-form-legend">
        <strong>Quantification</strong>
      </legend>
      <FieldWrapper>
        <DropDownList
          style={{ width: "100%" }}
          data={options}
          textField="label"
          dataItemKey="label"
          value={selected}
          onChange={(event) => setQuantificationMethod((event.value as QuantificationOption | null)?.value ?? undefined)}
        />
      </FieldWrapper>
    </fieldset>
  );
};
